(() => {
  const locale = document.documentElement.lang || 'es';
  const money = value => new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(value / 100);
  const number = value => new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value);
  const escape = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const initializeCalculators = () => document.querySelectorAll('[data-gotele-calc]').forEach(section => {
    if (section.dataset.goteleCalcInitialized === 'true') return;
    const messageNode = section.querySelector('[data-gotele-messages]');
    if (!messageNode) return;
    const messages = JSON.parse(messageNode.textContent);
    const text = (key, values = {}) => messages[key].replace(/\{(\w+)\}/g, (_, name) => values[name] ?? '');
    section.dataset.goteleCalcInitialized = 'true';
    const products = JSON.parse(section.querySelector('[data-gotele-products]').textContent);
    const form = section.querySelector('form');
    const result = section.querySelector('[data-result]');
    const eco = 'ecoestabilizador-kitomasgota';
    const roller = 'rodillo-superficies-rugosas';
    const variant = (handle, first, second) => products[handle]?.variants.find(item => item.available && (first == null || String(item.option1) === String(first)) && (second == null || String(item.option2) === String(second))) || null;
    const line = (handle, chosen, quantity, label) => chosen ? { handle, variant: chosen, quantity, label: label || products[handle].title } : null;
    const total = lines => lines.reduce((sum, item) => sum + item.variant.price * item.quantity, 0);
    const isBetter = (candidate, best) => !best || candidate.weight < best.weight || (candidate.weight === best.weight && candidate.cost < best.cost);
    const packs = kilograms => {
      if (kilograms <= 0.000001) return { lines: [], cost: 0, weight: 0 };
      const five = variant(eco, 5);
      const fifteen = variant(eco, 15);
      if (!five && !fifteen) return null;
      let best = null;
      for (let count15 = 0; count15 <= Math.ceil(kilograms / 15); count15++) {
        if (count15 && !fifteen) continue;
        const count5 = Math.max(0, Math.ceil((kilograms - 15 * count15 - 0.000001) / 5));
        if (count5 && !five) continue;
        const lines = [];
        if (count15) lines.push(line(eco, fifteen, count15, text('eco_15')));
        if (count5) lines.push(line(eco, five, count5, text('eco_5')));
        const candidate = { lines, cost: total(lines), weight: count15 * 15 + count5 * 5 };
        if (isBetter(candidate, best)) best = candidate;
      }
      return best;
    };
    const addRoller = option => {
      if (form.elements.roller.checked) {
        option.rollerMessage = text('own_roller');
        return option;
      }
      if (total(option.lines) >= 9000) {
        option.rollerMessage = text('free_roller');
        return option;
      }
      const chosen = variant(roller);
      if (chosen && total(option.lines) + chosen.price < 9000) {
        option.lines.push(line(roller, chosen, 1, text('roller')));
        option.rollerMessage = text('paid_roller');
      } else {
        option.rollerMessage = text('need_roller');
        option.rollerLink = products[roller]?.url;
      }
      return option;
    };
    const separate = (kilograms, system, scraperSize) => {
      const material = packs(kilograms);
      if (!material) return null;
      const lines = [...material.lines];
      const needed = [
        ['scraper', 'rasqueta-carburo-de-tungsteno', scraperSize, text('scraper', { size: scraperSize })],
        ['sprayer', 'sulfatadora-de-presion-5-l', null, text('sprayer')]
      ];
      if (system === 'brico') needed.push(['cup150', 'cazoleta-redonda-mediana', null, text('cup_150')]);
      else needed.push(['cup125', 'cazoleta-redonda-pequena', null, text('cup_125')], ['cup175', 'cazoleta-quitar-gotele-acero-inox-175-mm', null, text('cup_175')]);
      for (const [field, handle, size, label] of needed) {
        if (form.elements[field].checked) continue;
        const chosen = variant(handle, size);
        if (!chosen) return null;
        lines.push(line(handle, chosen, 1, label));
      }
      return addRoller({ title: text('separate_title'), lines, weight: material.weight, required: kilograms });
    };
    const bundle = (kilograms, system, scraperSize) => {
      const own = field => form.elements[field].checked;
      if (own('scraper') || own('cup150') || own('cup125') || own('cup175')) return null;
      let handle;
      let title;
      if (system === 'professional' && !own('sprayer')) {
        handle = 'eliminar-gotele-kit-kitomasgota';
        title = text('kit_professional');
      } else if (system === 'brico' && !own('sprayer')) {
        handle = 'quitar-gotele-kit-kitomasgota-brico';
        title = text('kit_brico');
      } else if (system === 'brico' && own('sprayer')) {
        handle = 'quitar-gotele-plastico';
        title = text('kit_without_sprayer');
      } else return null;
      let best = null;
      for (const size of [5, 15]) {
        const chosen = variant(handle, scraperSize, size);
        if (!chosen) continue;
        const extra = packs(Math.max(0, kilograms - size));
        if (!extra) continue;
        const lines = [line(handle, chosen, 1, title + ' · ' + size + ' kg'), ...extra.lines];
        const candidate = { title: text('bundle_title'), lines, weight: size + extra.weight, cost: total(lines), required: kilograms };
        if (isBetter(candidate, best)) best = candidate;
      }
      return best && addRoller(best);
    };
    const renderOption = (option, index) => {
      const items = option.lines.map(item => `<li><span>${escape(item.label)}${item.quantity > 1 ? ` × ${item.quantity}` : ''}</span><strong>${money(item.variant.price * item.quantity)}</strong></li>`).join('');
      const roundedMinimum = Math.ceil((option.required - 0.000001) / 5) * 5;
      const overage = option.weight > roundedMinimum ? `<p class="gotele-calc__disclaimer">${escape(text('stock_overage', { extra: number(option.weight - roundedMinimum) }))}</p>` : '';
      return `<article class="gotele-calc__option"><div class="gotele-calc__option-head"><h4>${escape(option.title)}</h4><strong>${money(total(option.lines))}</strong></div><ul>${items}</ul><p class="gotele-calc__coverage">${escape(text('coverage', { weight: number(option.weight), area: number(option.weight * 5) }))}</p>${overage}<p class="gotele-calc__roller">${escape(option.rollerMessage)}${option.rollerLink ? ` <a href="${escape(option.rollerLink)}">${escape(text('see_roller'))}</a>` : ''}</p><button type="button" data-add-option="${index}">${escape(text('add_selection'))}</button></article>`;
    };
    let options = [];
    const calculate = () => {
      const area = Number(form.elements.area.value.replace(',', '.'));
      if (!Number.isFinite(area) || area < 1 || area > 10000) {
        result.innerHTML = `<p class="gotele-calc__error">${escape(text('invalid_area'))}</p>`;
        options = [];
        return;
      }
      const kilograms = area / 5;
      options = [separate(kilograms, form.elements.system.value, form.elements.scraperSize.value), bundle(kilograms, form.elements.system.value, form.elements.scraperSize.value)].filter(Boolean);
      const estimate = `<div class="gotele-calc__estimate"><p>${escape(text('estimate_title'))}</p><strong>${number(area / 6)}–${number(kilograms)} kg</strong><small>${escape(text('estimate_basis', { weight: number(kilograms) }))}</small></div>`;
      result.innerHTML = estimate + (options.length ? `<div class="gotele-calc__options">${options.map(renderOption).join('')}</div>` : `<p class="gotele-calc__error">${escape(text('no_combination'))}</p>`);
    };
    form.addEventListener('submit', event => { event.preventDefault(); calculate(); });
    form.addEventListener('change', () => { if (form.elements.area.value) calculate(); });
    result.addEventListener('click', async event => {
      const button = event.target.closest('[data-add-option]');
      if (!button) return;
      const option = options[Number(button.dataset.addOption)];
      if (!option) return;
      button.disabled = true;
      button.textContent = text('adding');
      try {
        const response = await fetch(section.dataset.cartAddUrl + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: option.lines.map(item => ({ id: item.variant.id, quantity: item.quantity })) })
        });
        if (!response.ok) throw new Error((await response.json()).description || text('add_error'));
        window.location.assign(section.dataset.cartUrl);
      } catch (error) {
        button.disabled = false;
        button.textContent = text('add_selection');
        const notice = document.createElement('p');
        notice.className = 'gotele-calc__error';
        notice.textContent = error.message;
        button.after(notice);
      }
    });
    const queryArea = new URLSearchParams(window.location.search).get('area');
    if (queryArea) { form.elements.area.value = queryArea; calculate(); }
  });
  initializeCalculators();
  document.addEventListener('tradepro:product:updated', initializeCalculators);
  document.addEventListener('shopify:section:load', initializeCalculators);
})();
